/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { FC } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './learningPathListContent.module.scss';

const LearningPathListContent: FC<LearningPathListContentProps> = (props: LearningPathListContentProps) => {
    const { content, stateCheckCallback } = props;

    return (
        <div className={styles['learning-path-list-content-wrapper']}>
            {content &&
                content.length > 0 &&
                content.map((entry: ContentInfo) => (
                    <div key={entry.displayName} className={styles.item}>
                        {stateCheckCallback?.(entry) || (entry.state === 'completed' && <Icon name={'blueCheck'} />)}
                        <a href={entry.url} target="_blank" rel="noreferrer" className={styles.text}>
                            {entry.displayName} {entry.courseDisplayName ? `(${entry.courseDisplayName})` : ''}
                        </a>
                    </div>
                ))}
        </div>
    );
};

export interface LearningPathListContentProps {
    content: ContentInfo[] | undefined;
    stateCheckCallback?: (entry: any) => boolean;
}

interface ContentInfo {
    displayName: string;
    url: string;
    state?: string;
    courseDisplayName?: string;
}

export default LearningPathListContent;
